import React from "react";
import { makeStyles } from "@material-ui/styles";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";

const useStyles = makeStyles({
  formcontrol: {
    marginTop: "0",
    marginBottom: "16px",
  },
});

const TextInput = (props) => {
  const {
    field,
    form: { touched, errors },
    placeholder,
    min,
    type,
    max,
    required,
    disabled,
    autoFocus,
    label,
    inputProps,
    multiline,
    format,
    autoComplete,
  } = props;
  const classes = useStyles();
  const onChange = props.onChange
    ? (e) => props.onChange(e.target.value)
    : field.onChange;

  const value = props.format ? format(field.value) : field.value;

  return (
    <FormControl
      error={
        touched[field.name] &&
        errors[field.name] &&
        errors[field.name].length > 0
      }
      disabled={disabled}
      className={classes.formcontrol}
    >
      <InputLabel htmlFor={field.name} shrink={true} required={required}>
        {label}
      </InputLabel>
      <Input
        {...field}
        value={value}
        onChange={onChange}
        inputProps={inputProps}
        autoFocus={autoFocus}
        placeholder={placeholder}
        max={max}
        min={min}
        multiline={multiline}
        type={type}
        autoComplete={autoComplete}
      />
      {touched[field.name] && errors[field.name] && (
        <FormHelperText>{errors[field.name]}</FormHelperText>
      )}
    </FormControl>
  );
};

export default TextInput;
